import createLucideIcon from '../createLucideIcon';

const DivideCircle = createLucideIcon('DivideCircleIcon', [
  ['line', { x1: '8', y1: '12', x2: '16', y2: '12', key: '1myapg' }],
  ['line', { x1: '12', y1: '16', x2: '12', y2: '16', key: '4v5xkb' }],
  ['line', { x1: '12', y1: '8', x2: '12', y2: '8', key: '1vrb7x' }],
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
]);

export default DivideCircle;
